module.exports = __webpack_public_path__ + "static/media/bg-campaign-hero-02-mobile.fec49fd6.jpg";